// Thanks to Font Awesome (Free) for the icons! CC License https://fontawesome.com/license/free

import { ReactComponent as Check } from './check-solid.svg'
import { ReactComponent as Cog } from './cog-solid.svg'
import { ReactComponent as Ellipsis } from './ellipsis-solid.svg'
import { ReactComponent as File } from './file-alt-solid.svg'
import { ReactComponent as Download } from './file-download-solid.svg'
import { ReactComponent as FolderPlus } from './folder-plus-solid.svg'
import { ReactComponent as Glasses } from './glasses-solid.svg'
import { ReactComponent as Earth } from './globe-americas-solid.svg'
import { ReactComponent as Image } from './image-solid.svg'
import { ReactComponent as Edit } from './pen-solid.svg'
import { ReactComponent as Add } from './plus-circle-solid.svg'
import { ReactComponent as Plus } from './plus-solid.svg'
import { ReactComponent as Save } from './save-solid.svg'
import { ReactComponent as Search } from './search-solid.svg'
import { ReactComponent as SquarePlus } from './square-plus-regular.svg'
import { ReactComponent as Star } from './star-regular.svg'
import { ReactComponent as Sync } from './sync-alt-solid.svg'
import { ReactComponent as Table } from './table-solid.svg'
import { ReactComponent as Times } from './times-solid.svg'
import { ReactComponent as Trash } from './trash-solid.svg'
import { ReactComponent as TriangleExclamation } from './triangle-exclamation-solid.svg'
import { ReactComponent as Undo } from './undo-solid.svg'
import { ReactComponent as Upload } from './upload-solid.svg'

const icons = {
  check: Check,
  cog: Cog,
  ellipsis: Ellipsis,
  file: File,
  download: Download,
  'folder-plus': FolderPlus,
  glasses: Glasses,
  earth: Earth,
  image: Image,
  save: Save,
  table: Table,
  times: Times,
  trash: Trash,
  'triangle-exclamation': TriangleExclamation,
  undo: Undo,
  edit: Edit,
  add: Add,
  plus: Plus,
  star: Star,
  search: Search,
  'square-plus': SquarePlus,
  sync: Sync,
  upload: Upload,
}

export { icons, icons as default }
